import React, { Component } from 'react'
import Modal_Number from './Modal_Number'

export class Number extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: false
    };
  }

  openModal = () => {
    this.setState({ isModalOpen: true });
  };

  closeModal = () => {
    this.setState({ isModalOpen: false });
  };

  render() {
    return (
      <div className='number'>

        <img src={"./img/" + this.props.number.img} alt="Фотография номера"  onClick={this.openModal}/>
        <h2>{this.props.number.title}</h2>
        <p>{this.props.number.desc}</p>
        <b>{this.props.number.price}</b>
        <div 
          className='more' 
          onClick={this.openModal}
        >
          Подробнее
        </div>

        <Modal_Number 
          isOpen={this.state.isModalOpen}
          onClose={this.closeModal}
          number={this.props.number}
        />
      </div>
    );
  }
}

export default Number;